import * as React from 'react';
import { color } from '@metro-ui/tokens/js';
import { MonthBack, MonthForward } from './MonthButton';
import { Heading } from '../../Typography';
import { Layout } from '../../Layout';
export var DateNavbar = function (_a) {
    var onPreviousClick = _a.onPreviousClick, onNextClick = _a.onNextClick, title = _a.title;
    return (React.createElement(Layout, { className: "DayPicker-Navbar", style: {
            background: color.interaction,
            justifyContent: 'space-between',
        }, padding: "xxx-small" },
        React.createElement(MonthBack, { onClick: function () { return onPreviousClick(); } }),
        !!title && (React.createElement(Heading, { color: "inverted", variant: "h4", hasNoNativeMargin: true, align: "center" }, title)),
        React.createElement(MonthForward, { onClick: function () { return onNextClick(); } })));
};
//# sourceMappingURL=DateNavbar.js.map